import React from 'react';
import { render } from 'react-dom';

import type { FiveSymbolLocale } from '#common/utils/locale';

import AddToCartButton from '../../../../../components/Blocks/Store/Buttons/AddToCartButton/AddToCartButton';
import { goToCheckoutClick } from '../../../../../components/Blocks/Store/Buttons/GoToCheckoutButton';
import { UniversalCart } from '../../../../../scripts/blocks/store/cart/UniversalCart';
import { StoreAPIDataService } from '../../../../../scripts/blocks/store/services/StoreAPIDataService';
import { SelectorListItem } from '../../../../../types/store/selector-list-item';
import { addToCart } from '../../../../../utils/store/add-to-cart';
import { updateHidingButtons } from '../../../../../utils/store/update-hiding-buttons';

export const initCartButton = ({
  addToCartButtonWrapper,
  buyButton,
  checkoutButton,
  cart,
  storeAPIDataService,
  sku,
  locale,
  isTextNeeded,
  selectorList,
  className,
}: {
  addToCartButtonWrapper: HTMLElement;
  buyButton: HTMLElement;
  checkoutButton: HTMLElement;
  cart: UniversalCart;
  storeAPIDataService: StoreAPIDataService;
  sku: string;
  locale: FiveSymbolLocale;
  isTextNeeded: boolean;
  isServerSideRender: boolean;
  selectorList: SelectorListItem[];
  className?: string;
}) => {
  const cartButtonReactNode = (
    <>
      <AddToCartButton
        sku={sku}
        addToCart={addToCart({ cart, storeAPIDataService, sku, locale })}
        locale={locale}
        isTextNeeded={isTextNeeded}
        selectorList={selectorList}
        className={className}
      />
    </>
  );

  checkoutButton.addEventListener('click', () => {
    goToCheckoutClick({ cart, sku });
  });

  render(cartButtonReactNode, addToCartButtonWrapper);

  const props = {
    addToCartButton: addToCartButtonWrapper,
    buyButton,
    checkoutButton,
    cart,
    sku,
    storeAPIDataService,
  };
  cart.addListener(() => updateHidingButtons(props));
  updateHidingButtons(props);
};
